module.exports = __webpack_public_path__ + "static/media/empty-state.bc603b34.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/new-images/empty-state.svg
// module id = 324
// module chunks = 0